// -------------------
// FORMAT MONEY VALUE
// -------------------
/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format = window.Shopify.currencyFormat) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let moneyFormat = '{{amount_with_comma_separator}} €';
    let value = '';
    const placeholderRegex = /\{{([^}]+)\}}/g;
    const inputString = format || moneyFormat;
    let formatString = inputString;

    function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
    ) {
        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    let match;
    while (match = placeholderRegex.exec(inputString)) {
        switch (match[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'currency':
                value = window.Shopify.currency.active; 
                break;
        }

        formatString = formatString.replace(match[0], value);
    };

    return formatString;
}


